const sectionSelector = '.key-numbers-section';

const DEFAULT_DURATION_MS = 1800;
const DEFAULT_THRESHOLD = 0.4;

function easeOutCubic(t) {
	return 1 - (1 - t) ** 3;
}

function formatNumeric(value, decimals) {
	if (!Number.isFinite(value)) return '0';
	if (!decimals) return String(Math.round(value));
	return value.toFixed(decimals);
}

function animateCount(el, options = {}) {
	if (!el || el.dataset.animated === '1') return;

	const target = Number.parseFloat(el.dataset.value);
	if (!Number.isFinite(target)) return;

	el.dataset.animated = '1';

	const prefix = el.dataset.prefix || '';
	const suffix = el.dataset.suffix || '';
	const decimals = Number.parseInt(el.dataset.decimals || '0', 10) || 0;
	const finalText = el.textContent; // guarantee an exact match at the end

	const durationMs = Number.isFinite(options.durationMs) ? options.durationMs : DEFAULT_DURATION_MS;
	const easing = typeof options.easing === 'function' ? options.easing : easeOutCubic;

	const start = performance.now();

	const tick = (now) => {
		const rawProgress = (now - start) / durationMs;
		const progress = Math.min(1, Math.max(0, rawProgress));
		const eased = easing(progress);

		const current = target * eased;
		const formatted = formatNumeric(current, decimals);
		el.textContent = `${prefix}${formatted}${suffix}`;

		if (progress < 1) {
			requestAnimationFrame(tick);
		} else {
			el.textContent = finalText;
		}
	};

	requestAnimationFrame(tick);
}

function initCountUp(sectionElement) {
	const numbers = Array.from(sectionElement.querySelectorAll('.kn-number[data-value]'));
	if (!numbers.length) return;

	// Respect reduced motion: keep the original values without animation
	if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		numbers.forEach((el) => { el.dataset.animated = '1'; });
		return;
	}

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) return;
			animateCount(entry.target);
			observer.unobserve(entry.target);
		});
	}, { threshold: DEFAULT_THRESHOLD });

	numbers.forEach((el) => observer.observe(el));
}

const sectionCallBack = (sectionElement) => {
	initCountUp(sectionElement);
};

export { sectionSelector, sectionCallBack };
